import { kebabCase } from 'lodash';

/**
 * Where to go when the user switches project in the header's project selector: the same section
 * of the new project (/project/<old>/edits/<id> -> /project/<new>/edits). IDs after the section
 * belong to the old project, so they're dropped. Off a project page, returns undefined - switching
 * project shouldn't take the user anywhere.
 */
export const pathForProjectSwitch = (pathname: string, projectName: string): string | undefined => {
  const match = /^\/project\/[^/]+(?:\/([^/]+))?/.exec(pathname);
  if (!match) return undefined;

  const section = match[1];
  return `/project/${kebabCase(projectName)}${section ? `/${section}` : ''}`;
};
